const genres: any[] = [];
const ressorts: any[] = [];
const areas: any[] = [];
const isLoading: boolean = false;

export default {
  genres,
  ressorts,
  areas,
  isLoading
};
